import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFranchiseIsOpen } from "../../../utils/APICalls/APICalls";
import { franchiseIsOpenRes } from "../../../utils/types";

export const getFranchiseIsOpenData = createAsyncThunk(
  "fetchFranchiseIsOpen",
  async (args: { franchiseId: number; orderType: string | undefined }) => {
    const { franchiseId, orderType } = args;
    const franchiseIsOpen: { data: franchiseIsOpenRes } =
      await getFranchiseIsOpen(franchiseId);

    return { data: franchiseIsOpen.data, orderType };
  }
);
